import { GridLine as e } from "./GridLine.es.js";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
// lib/components/CropDialog/Grid.tsx
var i = () => /* @__PURE__ */ r(t, { children: [
	/* @__PURE__ */ n(e, {
		direction: "horizontal",
		offset: 33
	}),
	/* @__PURE__ */ n(e, {
		direction: "horizontal",
		offset: 67
	}),
	/* @__PURE__ */ n(e, {
		direction: "vertical",
		offset: 33
	}),
	/* @__PURE__ */ n(e, {
		direction: "vertical",
		offset: 67
	})
] });
export { i as Grid };
